export default "__VITE_ASSET__Dwe18tNY__"